import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {PreferenceService} from '../../../services/preference.service';
import { MailService } from '../../../services/mail.service';
import { switchMap, withLatestFrom, map, catchError, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { MailGroupActions } from '../actions/mail-group.action';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';

@Injectable()
export class MailGroupEffects {
  constructor(private actions$: Actions<MailGroupActions>,
              private store$: Store<fromStore.State>,
              private mailGroupService: MailService,
            ) {}

  ReadMailGroupList$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailGroupActionTypes.GetMailGroupList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.mailGroupService.ReadMailGroup(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertMailGroupList(res.msg.body)];
          } else {
            return of(new featureActions.GetMailGroupListFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetMailGroupListFail());
        })
      );
    })
  ));

  AddMailGroup$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailGroupActionTypes.AddMailGroup),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddMailGroup
      };
      const param = { ...action.payload, otp: user.otp };
      return this.mailGroupService.AddMailGroup(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Add Mail Group Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Mail Group Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));

  UpdateMailGroup$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailGroupActionTypes.UpdateMailGroup),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateMailGroup
      };
      const param = { ...action.payload, otp: user.otp };
      return this.mailGroupService.UpdateMailGroup(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Update Mail Group Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Update Mail Group Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));

  DeleteMailGroup$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailGroupActionTypes.DeleteMailGroup),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteMailGroup
      };
      const param = { ...action.payload, otp: user.otp };
      return this.mailGroupService.DeleteMailGroup(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Delete Mail Group Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Mail Group Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
